module.exports = __webpack_public_path__ + "1c534aded43dfbd7a844ab2aab33a8ef.svg";